import React, { useEffect, useState } from "react";
import {TreeNode} from "../../../../types/Post";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Typography} from "../../../../designSystem/components/Typography";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {CustomDialog} from "../../../../components/DialogCustom";

interface RenameCategoryDialogProps {
  initialCategory: TreeNode;
  onCancel: () => void;
  onSave: (newName: string) => void;
}

export const RenameCategoryDialog = ({ initialCategory, onCancel, onSave }: RenameCategoryDialogProps) => {
  const [name, setName] = useState<string>(initialCategory ? initialCategory.name : '');

  useEffect(() => setName(initialCategory ? initialCategory.name : ''), [initialCategory]);

  return (
    <CustomDialog>
      <div className="flex flex-col gap-4 text-left">
        <Typography variant="title">
          重新命名分類
        </Typography>
        <BaseInput
          label="新名稱"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="輸入分類名稱"
        />
        <div className="flex justify-end gap-2 mt-4">
          <ActionButton
            label="取消"
            onClick={onCancel}
            color="secondary"
          />
          <ActionButton
            label="儲存"
            iconName="fa-save"
            disabled={!name.trim()}
            onClick={() => onSave(name.trim())}
          />
        </div>
      </div>
    </CustomDialog>
  );
};
